const standings: { [key: string]: number } = {
  none: -1,
  new: 0,
  processing: 1,
  denied: 2,
  good: 3,
  overdue: 4,
  disabled: 5,
  cancelled: 6,
  'change processing': 7,
  'change denied': 8,
  'change finished': 9,
  authorizing: 10,
  'product specific processing': 11,
  'free trial': 12,
  'pending product specific processing': 13,
  'pending authorizing': 14,
  deleted: 15,
};

const activeStandings = [3, 4, 7, 8, 9, 11, 12, 13, 14];
const processingStandings = [1, 7, 10, 11, 13, 14];
//const overdueStandings = [4];
const needsCCStandings = [2, 5];
const cancelledStandings = [6];

interface Account {
  standing: string;
  products: number[];
  expirationDates?: { [productId: string]: Date };
}

export function hasAccount(standing?: number | string | null) {
  return (
    standing !== null &&
    standing !== undefined &&
    Number(standing) !== standings.none
  );
}
export function isActive(paidAccount?: Account | null) {
  return (
    paidAccount &&
    activeStandings.includes(Number(paidAccount.standing)) &&
    paidAccount.products.length
  );
}
export function isProcessing(standing?: number | string | null) {
  return hasAccount(standing) && processingStandings.includes(Number(standing));
}
export function isProblem(standing?: number | string | null) {
  return Number(standing) === standings.overdue;
}
export function isCancelled(paidAccount?: Account | null) {
  if (!paidAccount) {
    return false;
  }
  const standing = Number(paidAccount.standing);

  return (
    hasAccount(paidAccount.standing) &&
    (cancelledStandings.includes(standing) ||
      (activeStandings.includes(standing) &&
        !processingStandings.includes(standing) &&
        !paidAccount.products.length))
  );
}
export function willExpire(paidAccount: Account) {
  return (
    paidAccount.products &&
    paidAccount.products[0] in (paidAccount.expirationDates || {})
  );
}
export function needsCC(standing?: number | string | null) {
  return needsCCStandings.includes(Number(standing));
}
export function isInactive(standing?: number | string | null) {
  return hasAccount(standing) && !activeStandings.includes(Number(standing));
}
export function standingName(standing?: number | string | null) {
  return Object.keys(standings).find(
    (key) => standings[key] === Number(standing),
  );
}
